
import TaskCenterList from './src/task/TaskCenterList.vue' //任务列表
import TaskCenterDetails from './src/task/TaskCenterDetails.vue' //任务列表
import TaskCenterStatics from './src/task/TaskCenterStatics.vue' //任务统计
import TaskCenterStatDetail from './src/task/TaskCenterStatDetail.vue' //接收人统计详情

let views = {
  TaskCenterList,
  TaskCenterDetails,
  TaskCenterStatics,  
  TaskCenterStatDetail
};

export default views;